/* eslint-disable prettier/prettier */
import React from 'react';
import styles from '../../styles/scheduler/SchedulePage.module.css';
import ScheduleCalendar from '../../components/Schedule/ScheduleCalendar';

const SchedulePage: React.FC = () => {
	return (
		<div className={styles.page}>
			<header className={styles.header}>
				<div className={styles.headerContent}>
					<h1 className={styles.title}>Mock Schedule</h1>
					<p className={styles.subtitle}>
						weekly and monthly activities
					</p>
				</div>
			</header>
			<main className={styles.main}>
				<ScheduleCalendar />
			</main>
		</div>
	);
};

export default SchedulePage;
